import React from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import orderSlipDesign1 from "../Assets/Design/Order Slip design.png"; // optional rename in your folders
import lkiLogo from "../Assets/Design/LKI-logo.png";
import thankyou from "../Assets/Design/thankyou.png";
import "./SampleOrderSlip.scss";

function SampleOrderSlip() {
  const exportPDF = () => {
    const orderSlip = document.getElementById("order-slip");

    html2canvas(orderSlip, {
      backgroundColor: "#ffffff",
      useCORS: true,
      scale: 2,
    }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("order-slip.pdf");
    });
  };

  const exportJPG = () => {
    const orderSlip = document.getElementById("order-slip");

    html2canvas(orderSlip, {
      backgroundColor: "#ffffff",
      useCORS: true,
      scale: 2,
    }).then((canvas) => {
      const link = document.createElement("a");
      link.download = "order-slip.jpg";
      link.href = canvas.toDataURL("image/jpeg");
      link.click();
    });
  };

  return (
    <div>
      <div className="order-slip" id="order-slip">
        <img className="order-slip-design1" src={orderSlipDesign1} alt="" />

        <div className="content-container">
          <h1>ORDER SLIP</h1>
          <div className="logo-wrapper">
            <img src={lkiLogo} alt="LKI Logo" />
          </div>

          <h2>Name: Jesson Buanjug</h2>

          <span>
            <b>Address:</b> Unit 2310 Amaia Skies Shaw North Tower, Shaw Blvd,
            Samat St, Mandaluyong City
          </span>
          <span>
            <b> Contact Number:</b> 09052197939
          </span>
          <br />
          <span className="date">Date: November 17, 2024</span>
          <div className="orderno-wrapper">
            <span>Order no. 0002314 </span>
          </div>
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>Description</th>
                  <th>QTY</th>
                  <th>Price</th>
                  <th>DP Price</th>
                  <th>ETA</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    Pettitrama series LOGBOX RE BIRTH ONE PIECE GEAR5 Special
                    Set
                  </td>
                  <td>1</td>
                  <td>1650</td>
                  <td>500</td>
                  <td>Q1, 2025</td>
                </tr>

                <tr>
                  <td>ONE PIECE PALDOLCE COLLECTION VOL.2 (VER.A)</td>
                  <td>1</td>
                  <td>590</td>
                  <td>200</td>
                  <td>Q1, 2025</td>
                </tr>

                <tr>
                  <td>ONE PIECE PALDOLCE COLLECTION VOL.2 (VER.B)</td>
                  <td>1</td>
                  <td>590</td>
                  <td>200</td>
                  <td>Q1, 2025</td>
                </tr>

                <tr>
                  <td>ONE PIECE PALDOLCE COLLECTION VOL.2 (VER.C)</td>
                  <td>1</td>
                  <td>590</td>
                  <td>200</td>
                  <td>Q1, 2025</td>
                </tr>

                <tr>
                  <td>NARUTO SHIPPUDEN PANEL SPECTACLE SENJU HASHIRAMA</td>
                  <td>1</td>
                  <td>800</td>
                  <td>200</td>
                  <td>Q1, 2025</td>
                </tr>

                <tr>
                  <td>DXF ～ THE GRANDLINE SERIES ～ EGGHEAD STUSSY</td>
                  <td>1</td>
                  <td>640</td>
                  <td>200</td>
                  <td>Q1, 2025</td>
                </tr>

                <tr>
                  <td>ONE PIECE BATTLE RECORD COLLECTION - NAMI</td>
                  <td>1</td>
                  <td>700</td>
                  <td>200</td>
                  <td>Q1, 2025</td>
                </tr>

                <tr>
                  <td>Luminast Hatsune Miku - Etoile</td>
                  <td>1</td>
                  <td>815</td>
                  <td>200</td>
                  <td>Q2, 2025</td>
                </tr>

                <tr>
                  <td>SITTING FIGURE FRIEREN</td>
                  <td>1</td>
                  <td>700</td>
                  <td>200</td>
                  <td>Q1, 2025</td>
                </tr>

                <tr>
                  <td>SITTING FIGURE FERN</td>
                  <td>1</td>
                  <td>700</td>
                  <td>200</td>
                  <td>Q1, 2025</td>
                </tr>

                <tr>
                  <td>Sakura Kinomoto (Clow Card) Figure</td>
                  <td>1</td>
                  <td>850</td>
                  <td>200</td>
                  <td>Q2, 2025</td>
                </tr>

                <tr>
                  <td>Solid Edge Works Frieza II</td>
                  <td>1</td>
                  <td>720</td>
                  <td>200</td>
                  <td>Q2, 2025</td>
                </tr>

                <tr>
                  <td>Vibration Stars Kakashi Hatake</td>
                  <td>1</td>
                  <td>720</td>
                  <td>200</td>
                  <td>Q2, 2025</td>
                </tr>

                <tr>
                  <td>Naruto Memorable Saga Naruto Uzumaki II</td>
                  <td>1</td>
                  <td>780</td>
                  <td>200</td>
                  <td>Q2, 2025</td>
                </tr>

                <tr>
                  <td>Panel Spectacle Tobirama Senju</td>
                  <td>1</td>
                  <td>830</td>
                  <td>200</td>
                  <td>Q2, 2025</td>
                </tr>

                <tr>
                  <td>One Piece The Shukko Roronoa Zoro (Egghead Ver.)</td>
                  <td>1</td>
                  <td>780</td>
                  <td>200</td>
                  <td>Q2, 2025</td>
                </tr>

                <tr>
                  <td>One Piece Grandista Monkey D. Luffy (Gear 5)</td>
                  <td>1</td>
                  <td>760</td>
                  <td>200</td>
                  <td>Q2, 2025</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <img className="thankyou" src={thankyou} />
      </div>

      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <button onClick={exportPDF} style={{ marginRight: "10px" }}>
          Download ORDER SLIP PDF
        </button>

        <button onClick={exportJPG}>Download ORDER SLIP JPG</button>
      </div>
    </div>
  );
}

export default SampleOrderSlip;
